import { render, staticRenderFns } from "./myfoot.vue?vue&type=template&id=e6cae438&scoped=true"
import script from "./myfoot.vue?vue&type=script&lang=js"
export * from "./myfoot.vue?vue&type=script&lang=js"
import style0 from "./myfoot.vue?vue&type=style&index=0&id=e6cae438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cae438",
  null
  
)

export default component.exports